<template src="./RegisterMarketplaceCategoria.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      categorias: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchCategorias: "",
      popupCategoria: false,
      popupCategoriaData: {
        name: undefined,
        description: undefined,
        active: undefined,
        id: undefined,
      },
      invalidFields: {
        name: false,
        description: false
      },
      dangerMessage: "Campo obrigatório",
      toggleActiveId : null
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
   watch: {
    'popupCategoriaData.name': function(newVal) {
        const vm = this;
        vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.name;
    },
    'popupCategoriaData.description': function(newVal) {
        const vm = this;
        vm.invalidFields.description = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.description;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getCategorias();
    },
    getCategorias() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "marketplace/categorias?page=" + page + "&search=" + vm.searchCategorias + "&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.categorias = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        });
    },
    changePagination() {
      const vm = this;
      vm.getCategorias();
    },
    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-category");
    },
    toggleActive() {
      const vm = this;
      vm.axios
      .put(
        vm.$store.state.filooServer + "marketplace/categorias/toggle/" + vm.toggleActiveId, {}, {
          headers: {
          Authorization: vm.$session.get("bearerDefault")
          },
        }
      )
      .then(function (response) {
        if (response.status == 200) {
          vm.$bvModal.hide("modal-change-status-category");
          vm.showNotifySuccess("Operação realizada","O status da categoria foi alterado com sucesso", 3000);
          vm.getCategorias();
        }
      }).catch(function () {
        vm.$bvModal.hide("modal-change-status-category");
        vm.showNotifyError("Não foi possível alterar o status da especialidade", 6000);
      })
      .finally(function() {
        vm.$bvModal.hide("modal-change-status-category");
      });
    },
    addNewCategoriaPopup() {
      const vm = this;
      vm.invalidFields.name = false;
      vm.invalidFields.description = false;
      vm.popupCategoriaData = {
        active: true,
        id: undefined,
        name: undefined,
        description: undefined,
      }
      vm.popupCategoria = true;
    },
    editCategoriaPopup(categoria) {
      const vm = this;
      vm.invalidFields.name = false;
      vm.invalidFields.description = false;
      vm.popupCategoriaData = {
        active: categoria.active,
        id: categoria.id,
        name: categoria.name,
        description: categoria.description,
      }
      vm.popupCategoria = true;
    },
    addNewCategoria() {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupCategoriaData.name);
      vm.invalidFields.description = vm.testNullUndefinedEmpty(vm.popupCategoriaData.description);
      if (!vm.invalidFields.name && !vm.invalidFields.description) {
        vm.axios
        .post(
          vm.$store.state.filooServer + "marketplace/categorias", vm.popupCategoriaData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupCategoria = false;
            vm.getCategorias();
            vm.$swal({
              title: "Categoria salva!",
              icon: "success",
            });
          }
        })
        .catch(function () {
          vm.$vs.notify({
            title: "Ocorreu um erro",
            text: "Categoria não salva",
            color: "danger",
            icon: "error",
          time: 6000
          });
        });
      } 
    },
    editCategoria() {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupCategoriaData.name);
      vm.invalidFields.description = vm.testNullUndefinedEmpty(vm.popupCategoriaData.description);
      if(!vm.invalidFields.name && !vm.invalidFields.description) {
        vm.axios
        .put(
          vm.$store.state.filooServer + "marketplace/categorias", vm.popupCategoriaData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupCategoria = false;
            vm.getCategorias();
            vm.$swal({
              title: "Categoria salva!",
              icon: "success",
            });
          }
        })
        .catch(function () {
          vm.$vs.notify({
            title: "Ocorreu um erro",
            text: "Categoria não salva",
            color: "danger",
            icon: "error",
            time: 6000
          });
        });
      }
    },
    changeSearchCategorias() {
      const vm = this;
      vm.currentx = 1;
      vm.getCategorias();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },

  },
};
</script>
<style lang="scss" src="./RegisterMarketplaceCategoria.scss">
</style>